module.exports = __webpack_public_path__ + "img/415325_83A24E_678239_748C3C-256px.f02bc653.png";